import { render, staticRenderFns } from "./socialInsurance.vue?vue&type=template&id=0b6ed3f9&scoped=true&"
import script from "./socialInsurance.vue?vue&type=script&lang=js&"
export * from "./socialInsurance.vue?vue&type=script&lang=js&"
import style0 from "./socialInsurance.vue?vue&type=style&index=0&id=0b6ed3f9&prod&lang=scss&scoped=true&"
import style1 from "./socialInsurance.vue?vue&type=style&index=1&id=0b6ed3f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ed3f9",
  null
  
)

export default component.exports